import PropTypes from 'prop-types';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';

import { componentsSize } from 'constants/components';
import { ButtonCloseDialog } from 'components/simple';

const styles = {
  buttonCloseEdit: {
    top: 50,
    right: 60,
    zIndex: 1,
  },
  editablePaper: ({ palette, breakpoints }) => ({
    position: 'relative',
    backgroundColor: palette.colors.lightPale,
    paddingBlock: 6,
    paddingInline: 5,
    borderRadius: 5,
    overflow: 'hidden',

    '.MuiInputBase-root': {
      height: 40,
      [breakpoints.up('md')]: {
        height: 56,
      },
    },
  }),
  addItemButton: {
    alignSelf: 'flex-start',
  },
};

export const EditableQuestionWrapper = ({
  children,
  isDisabledSaving,
  saveButtonLabel,
  isEnabledItemsAdding,
  addItemsButtonLabel,
  onCloseEdit,
  onSaveQuestion,
  onAddItems,
  questionError = null,
}) => {
  return (
    <Paper elevation={0} sx={styles.editablePaper}>
      <ButtonCloseDialog size={componentsSize.large} customStyles={styles.buttonCloseEdit} onClick={onCloseEdit} />

      <Stack mb={5} spacing={3}>
        <Box>{children}</Box>

        {isEnabledItemsAdding && (
          <Button variant="text" onClick={onAddItems} sx={styles.addItemButton}>
            {`+ ${addItemsButtonLabel}`}
          </Button>
        )}
      </Stack>

      <Stack spacing={2} direction="row" alignItems="center">
        <Button color="secondary" onClick={onSaveQuestion} disabled={isDisabledSaving}>
          {saveButtonLabel}
        </Button>

        {questionError && (
          <Typography variant="body2" color="error">
            {questionError}
          </Typography>
        )}
      </Stack>
    </Paper>
  );
};

EditableQuestionWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  isDisabledSaving: PropTypes.bool.isRequired,
  saveButtonLabel: PropTypes.string.isRequired,
  isEnabledItemsAdding: PropTypes.bool.isRequired,
  addItemsButtonLabel: PropTypes.string.isRequired,
  onCloseEdit: PropTypes.func.isRequired,
  onSaveQuestion: PropTypes.func.isRequired,
  onAddItems: PropTypes.func.isRequired,
  questionError: PropTypes.string,
};
